<template>
  <div :style="{ height: height }" class="sellCenter">
    <div class="inputWrap">
      <div class="header" ref="header">
        <div class="StoreWallateRechargeTitle">
          <el-page-header @back="goBack" content=""> </el-page-header>
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'staffPage' }"
              ><span class="titleText">员工管理</span></el-breadcrumb-item
            >
            <el-breadcrumb-item :to="{ name: 'addStaff' }"
              ><span class="titleText">添加员工</span></el-breadcrumb-item
            >
          </el-breadcrumb>
        </div>

        <div></div>
      </div>

      <div
        :style="{ height: formHeight + 'px', backgroundColor: '#fff' }"
        class="formBox"
      >
        <el-form ref="form" :model="form" size="mini" label-width="80px">
          <div class="formInfo">
            <el-alert
              v-show="showErr.show"
              :title="showErr.text"
              type="warning"
              :closable="false"
              show-icon
            >
            </el-alert>
          </div>
          <div class="formInnerBox" :style="{ height: formHeight - 40 + 'px' }">
            <!-- <el-form-item label="员工昵称: ">
              <div class="userName">{{ currentEditRow.name }}</div>
            </el-form-item>
            <el-form-item label="员工角色: ">
              <el-checkbox-group v-model="form.checkList">
                <el-checkbox
                  v-for="item in roleList"
                  :key="item.id"
                  :label="item.name"
                ></el-checkbox>
              </el-checkbox-group>
            </el-form-item> -->
            <el-form-item label="身份证号">
              <el-input v-model="form.ID_card"></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input maxlength="11" v-model="form.telphone"></el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="info" size="mini" @click="onSubmit">
                添加新员工
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { addEmpUrl } from "@/api/api";

export default {
  props: ["height"],
  data() {
    return {
      form: {
        ID_card: "",
        telphone: "",
      },
      formHeight: "",
      showErr: {
        show: false,
        text: "",
      },
      roleList: [],
    };
  },
  created() {},

  mounted() {
    this.setFormHeight();
    window.addEventListener("resize", this.setFormHeight);
  },
  computed: {
    ...mapState(["userInfo", "companyInfo", "currentEditRow"]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    setFormHeight() {
      setTimeout(() => {
        this.formHeight =
          parseFloat(this.height) - this.$refs.header.clientHeight - 100;
      }, 100);
    },
    getRId() {
      let { checkList } = this.form;
      if (checkList.length) {
        let arr = [];
        this.roleList.filter((item) => {
          let _some = checkList.some((m) => m == item.name);
          if (_some) {
            arr.push(item.id);
          }
        });
        return arr.join(",");
      } else {
        return "4";
      }
    },
    onSubmit() {
      console.log(this.form);
      let { ID_card,telphone } = this.form;

      if (!ID_card.trim()) {
        this.showErr = {
          show: true,
          text: "请填写身份证号",
        };
        return;
      }
      if (!telphone.trim()) {
        this.showErr = {
          show: true,
          text: "请填写手机号",
        };
        return;
      }

      this.showErr = {
        show: false,
        text: "",
      };

      let { access_token } = this.userInfo;

      // return
      let url = addEmpUrl;

      let data = {
        access_token,
        storeId: this.userInfo.storeId,
        ID_card: ID_card.replace(/\s/g, ""),
        telphone: telphone.replace(/\s/g, ""),
      };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log(res);
          if (res.data.resultCode == 1) {
            const { data } = res.data;
            console.log(data);
            this.$router.go(-1);
            this.$message({
              message: "添加成功",
              type: "success",
            });
          } else {
            this.$alert(JSON.stringify(res.data.resultMsg || "请求异常"));
          }
        })
        .catch((err) => {
          if (err) {
            this.$alert(JSON.stringify(err));
          } else {
            this.$alert("请求异常");
          }
        });
    },
  },
};
</script>
<style scoped lang="less">
.sellCenter {
  overflow: hidden;
}
.warning {
  color: #f40;
  margin-left: 10px;
}
.inputWrap {
  margin: 20px;
}
.formBox {
  margin-top: 20px;
  padding: 20px;
}
.forItem {
  width: 266px;
}
.formInnerBox {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: flex-start;
  max-width: 550px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.formInfo {
  width: 300px;
  height: 30px;
  margin-bottom: 20px;
}
.userName {
  color: #666;
  font-size: 13px;
}
.StoreWallateRechargeTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/AddStaff.vue